export default {
  //代码里的key(唯一标识): '越南语',
  lang: 'vi',
  appIntroduction: 'Xem phim miễn phí mọi lúc mọi nơi',
  noMoreTip: 'Bạn đã xem hết rồi, không còn nội dung khác nữa~',
  navigator: {
    home: 'Trang chủ',
    all: 'Tất cả nội dung',
    news: 'Tin tức',
    download: 'Tải APP',
    contact: 'về chúng tôi',
    joinUs: 'Tham gia với chúng tôi'
  },
  seo: {
    title: 'Loklok-Global HD Video Xem trực tuyến miễn phí',
    keywords: 'Loklok, Loklok app, loklok tv, Loklok official website, Loklok web,Loklok movie,Xem online, Xem miễn phí, Xem phim miễn phí,new movies,tv show,Snowdrop,Hotel Transylvania,Encanto,The Silent Sea,Jujutsu Kaisen,9-1-1: Lone Star,Hotel Transylvania,Dragons,SnowdropOur Beloved SummerDemon SlayerHappinessSing 2Ranking of KingsDemon SlayerAttack on TitanTrue BeautyVincenzoAttack on Titan The Final SeasonJujutsu KaisenThe HandmaidenTokyo RevengersNeverthelessItaewon ClassSquid GameCrash Landing on YouEuphoriaAttack on TitanHometown Cha-Cha-Cha',
    description: 'Popular episodes updated quickly,American hot series,Tension, comedy, thriller,Newest hottest dramasall in Loklok',
    ogImage: 'https://static.loklok.video/img/tw-vi.png',
    index: {
      title: 'Loklok - Xem phim HD trực tuyến miễn phí - Đề xuất phim được xếp hạng cao nhất',
      keywords: 'Loklok, app Loklok, tải loklok, cài đặt loklok, loklok pc, loklok apk, Xem online, Xem miễn phí, Xem phim miễn phí,loklok ios, loklok android, loklok cho iOS, loklok cho android, loklok android tv, loklok chromecast, kdrama, k-drama, phim truyền hình Hàn Quốc, phòng vé, phim mỹ, phim miền tây, phim bom tấn, phim thái, phim thái lan, phim truyền hình, phim truyền hình dài tập, Anime, hoạt hình, hoạt hình, show truyền hình, yaoi, yuri, bl, gl, Hollywood, Bollywood, zombie, One piece, Naruto, ngoại tình, tất cả chúng ta đều chết, all of us are dead',
      description: 'Loklok là nền tảng video trực tuyến video để bạn xem các chương trình truyền hình, phim điện ảnh, hoạt hình từ khắp nơi trên thế giới! Với nội dung phim phong phú, bạn có thể chọn phụ đề đa ngôn ngữ và chất lượng hình ảnh siêu HD 4k, các bộ phim mới nổi tiếng được phát hành hàng ngày!'
    },
    allPage: {
      title: 'Loklok - Truyền phát video HD trực tuyến miễn phí trên toàn thế giới - Phim, Phim truyền hình, Hoạt hình, Hollywood, Phim truyền hình Thái Lan, Phim truyền hình Hàn Quốc, Phim truyền hình Nhật Bản, muốn gì có đó',
      keywords: 'Loklok, app Loklok, tải loklok, loklok pc, loklok apk, hoạt hình, anime,Xem online, Xem miễn phí, Xem phim miễn phí, phim bom tấn , tập mới, phim sắp ra mắt, phát hành mới năm 2022 ,chiếu sớm, khoa học viễn tưởng , lãng mạn ngọt ngào, hài hành động, tình yêu, phim miễn phí, miễn phí phim trực tuyến, ứng dụng phim miễn phí, tất cả chúng ta đều đã chết, F4 Thái Lan: Boys Over Flowers, Euphoria Season 2, Twenty lăm 21, Dự Báo Tình Yêu Và Thời Tiết), Bác sĩ Ma, Vẻ đẹp thực sự, Encanto, Encanto, From, Hẹn hò chốn công sở, Hoa tuyết điểm, Snowdrop, Rookie Cảnh sát, 2till together',
      description: 'Loklok có lượng lớn các phim điện ảnh và truyền hình nổi tiếng, các bộ phim điện ảnh và phim truyền hình mới nhất, hot nhất đều được xem miễn phí! Phim độ nét cao đa dạng, người dùng được trải nghiệm cá nhân hóa và xem mọi bộ phim nổi tiếng ở đây.'
    },
    articles: {
      title: 'Tin tức Loklok - thông tin phim và truyền hình mới nhất và hot nhất, các bài đánh giá phim nổi tiếng và tuyển tập các bộ phim hay nhất trên toàn cầu đáng xem nhất, tất cả thông tin chi tiết bạn muốn xem về phim của mình đều có sẵn cho bạn hàng ngày!',
      keywords: 'Loklok, ứng dụng Loklok, tải loklok, loklok pc, loklok apk, Xem online, Xem miễn phí, Xem phim miễn phí,thông tin phim và truyền hình mới nhất, đề xuất phim, đánh giá phim nổi tiếng, phim và truyền hình 2022, phim chiếu rạp, phim đáng xem 2022, phim 2022 phải xem, phim chiếu rạp 2022, phim sắp chiếu 2023 , Bóng ma Anh Quốc Season 6, tấn công vào mùa cuối cùng của người khổng lồ, mùa hè yêu dấu của chúng ta, Khách Sạn Huyền Bí 4, Hạnh phúc',
      description: 'Bạn có thể tìm thấy nội dung phim điện ảnh và phim truyền hình nổi tiếng của Loklok, tất cả các loại bảng xếp hạng doanh thu phòng vé và phim truyền hình đều được cập nhật trong 24 giờ, đồng thời các phim điện ảnh và phim truyền hình nổi tiếng đều được trình chiếu theo thời gian nhanh chóng, hãy đến với Loklok theo dõi các bộ phim của bạn.'
    },
    download: {
      title: 'Tải xuống phiên bản chính thức mới nhất của Loklok, Google Play, App Store, tải xuống apk',
      keywords: 'Loklok, ứng dụng Loklok, tải loklok, loklok pc, loklok apk, Xem online, Xem miễn phí, Xem phim miễn phí,tải loklok, cài đặt loklok, download loklok, tải loklok ios, tải loklok cho android, loklok googleplay, tải loklok pc, loklok phiên bản mới nhất, trang web chính thức của loklok, cách tải xuống Loklok, Máy tính để bàn Loklok, Loklok pad',
      description: 'Tải xuống phiên bản chính thức mới nhất của Ứng dụng loklok Cung cấp kênh cài đặt Google Play, App Store, apk'
    },
    search: {
      title: 'Loklok - Tìm phim yêu thích của bạn',
      keywords: 'Loklok, ứng dụng Loklok, tải loklok, loklok pc, loklok apk,Xem online, Xem miễn phí, Xem phim miễn phí, phim truyền hình tìm kiếm, tập tìm kiếm, bảng xếp hạng phim ăn khách, bảng xếp hạng phòng vé, bảng xếp hạng phim, bảng xếp hạng phim truyền hình, bảng xếp hạng phim, xếp hạng phim truyền hình Hàn Quốc, xếp hạng phim truyền hình Thái Lan, top 10 phim, top 10 phim truyền hình, top 100 phim chiếu rạp 2022, top 100 phim chiếu rạp 2021, TOP 100 phim truyền hình được mong chờ nhất năm 2022, phim điện ảnh năm 2022 được xem nhiều nhất, phim chiếu rạp hay nhất năm 2021, Tất cả chúng ta đều đã chết, All of Us Are Dead, F4 Thái Lan, F4 Thailand, Hải Tặc: Kho Báu Hoàng Gia Cuối Cùng, True Beauty, Vẻ đẹp đích thực, Euphoria, Hưng Phấn, Rookie Cops, Người Nhện: Không còn nhà, Người Nhện, Spider-Man, Bác sĩ Ma, Encanto',
      description: 'Loklok dựa theo tổng lượt xem và mức độ phổ biến tìm kiếm theo thời gian thực đề xuất các bộ phim truyền hình, điện ảnh nổi tiếng toàn cầu nổi tiếng nhất theo cập nhật hàng ngày và cải thiện trải nghiệm xem. '
    },
    contact: {

    }
  },
  globalTip: {
    emptyTip: 'Không tìm thấy nguồn hiện nay',
    searchOther: 'Thử tìm kiếm phim hoặc TV show khác'
  },
  loginModule: {
    title: 'Đăng nhập',
    loginMethod: 'Sử dụng App loklok để quét mã QR',
    loginMethodTip: '(Cần cập nhật phiên bản 1.7.0 trở lên) ',
    howToDownload: 'Làm thế nào để tải loklok',
    clickMe: 'Nhấp vào tôi',
    loginSuccess: 'Đăng nhập thành công',
    loginFailed: 'Đăng nhập lỗi',
    codeExpired: 'Mã QR hết hạn rồi!',
    refreshButton: 'Làm mới',
    loginButton: 'Đăng nhập',
    loginTip: 'Đăng nhập để xem miễn phí tất cả',
    logoutButton: 'Đăng xuất',
    logoutTip: 'Tận hưởng bộ phim nhé!',
    areYouSure: 'Bạn chắc chắn thoát đăng nhập không?',
    sure: 'Xác nhận',
    cancel: 'Hủy'
  },
  toTop: {
    downloadApp: 'Tải App',
    backToTop: 'Trở lại phần đầu'
  },
  indexPage: {
    title: 'LolokTV',
    more: 'Còn nữa',
    seeMore: 'Xem thêm'
  },
  searchPage: {
    resultTitle: 'Nội dung sau được tìm kiếm cho bạn',
    rank: 'Xu hướng của Loklok',
    play: 'Play',
    popularSearch: 'Tìm kiếm hot',
    top1: 'Xếp thứ 1',
    top2: 'Xếp thứ 2',
    top3: 'Xếp thứ 3',
    top4: 'Xếp thứ 4',
    top5: 'Xếp thứ 5',
    top6: 'Xếp thứ 6',
    top7: 'Xếp thứ 7',
    top8: 'Xếp thứ 8',
    top9: 'Xếp thứ 9',
    top10: 'Xếp thứ 10',
    emptyTip: 'Xin lỗi, chúng tôi không có nội dung này',
    emptyDesc: 'Thử tìm phim khác nhé'
  },
  filterPage: {
    emptyTip: 'Xin lỗi, chúng tôi không có nội dung này',
    emptyDesc: 'Thử tìm phim khác nhé'
  },
  newsPage: {
    listTitle: 'Tin mới nhất'
  },
  downloadPage: {
    scanQR: 'Quét mã QR và tải App',
    title1: 'Phim HOT',
    tip1: 'Xem miễn phí mọi lúc mọi nơi',
    title2: 'Phụ đề đa ngôn ngữ',
    tip2: 'Xem phim dễ dàng',
    title3: 'PC/ điện thoại đồng bộ liên tục'
  },
  detailPage: {
    autoTranslation: 'Dịch tự động',
    fiveMiniteTip: 'Chỉ 5 phút, Xem full bộ phim',
    loginTip2InDetailPage: 'Sử dụng App loklok quét mã QR phía dưới, sau khi đăng nhập xong bạn sẽ được xem nội dung còn lại',
    category: 'Phân loại',
    moreDesc: 'Còn nữa',
    youMayLike: 'Bạn có thể sẽ thích',
    relatedSeries: 'Nội dung tương tự',
    norelatedSeries: 'Không có nội dung liên quan',
    emptyDesc: 'Xin lỗi, chúng tôi không có nội dung này',
    emptyTip: 'Xin lỗi, chúng tôi không có nội dung này',
    vip: {
      dialog: {
        t1: 'Kích hoạt VIP',
        t2: 'Muốn xem hết nội dung vui lòng vào App và kích hoạt VIP',
        t3: 'App có thể được tải xuống theo các cách sau',
        t4: 'Đã có VIP? Vui lòng <span class="active">nhấp vào đây</span> để đăng nhập',
        t5: 'Đã có VIP? Vui lòng <span class="active">làm mới</span> để tiếp tục xem',
        t6: 'Bạn đã xem được {num} phút, nếu muốn tiếp tục xem hết video, vui lòng sử dụng App, hoặc sau khi kích hoạt VIP tại App, bạn có thể xem tiếp video.'
      },
      player: {
        tip1: 'Chỉ được xem trong {num} phút, để xem trọn bộ vui lòng <span class="active">vào app</span> hoặc <span class="active">kích hoạt VIP</span>'
      },
      episodes: {
        tip1: 'Trở thành VIP và xem toàn bộ nội dung'
      }
    }
  },
  playerModule: {
    NETWORK_LOADING: 'Trình duyệt đang tải dữ liệu về',
    NETWORK_NO_SOURCE: 'Chưa tìm được nguồn video/phim',
    MEDIA_ERR_ABORTED: 'Quá trình tải bị người dùng chặn',
    MEDIA_ERR_NETWORK: 'Lỗi khi đang tải về',
    MEDIA_ERR_DECODE: 'Giải tích lỗi: không thể bật',
    MEDIA_ERR_SRC_NOT_SUPPORTED: 'Không hỗ trợ định dạng video/phim',
    REPLAY: 'Bật lại',
    ERROR: 'Kết nối mạng có vấn đề',
    PLAY_TIPS: 'Bật',
    PAUSE_TIPS: 'Dừng',
    PLAYNEXT_TIPS: 'Tập sau',
    DOWNLOAD_TIPS: 'Tải về',
    ROTATE_TIPS: 'Xoay',
    RELOAD_TIPS: 'Tải lại',
    FULLSCREEN_TIPS: 'Mở to cả màn hình',
    EXITFULLSCREEN_TIPS: 'Thoát cả màn hình',
    CSSFULLSCREEN_TIPS: 'Chế độ cả màn hình',
    EXITCSSFULLSCREEN_TIPS: 'Thoát chế độ cả màn hình',
    TEXTTRACK: 'Phụ đề',
    PIP: 'Picture in picture',
    MINIPLAYER: 'Trình phát thu nhỏ',
    SCREENSHOT: 'Cắt màn hình',
    LIVE: 'Đang livetream',
    OFF: 'Đóng',
    MINIPLAYER_DRAG: 'Nhấp và giữ để kéo video',
    AIRPLAY_TIPS: 'Airplay',
    onlyPlayTip: 'Chỉ xem được {msg} phút, đăng nhập xem toàn tập',
    loginTextButton: 'Đăng nhập',
    replayButton: 'Replay',
    nextButton: 'Tập sau',
    refreshButton: 'Làm mới',
    episode: 'Tập'
  },
  contact: {
    business: 'Hợp tác thương mại',
    question: 'Ý kiến & Phản hồi'
  },
  download_nd: {
    desc: 'Số lượng lớn phim xem miễn phí',
    scanQR: 'Quét mã QR để tải App về hoặc '
  },
  win: {
    feedback: {
      que: 'Giải thích Câu hỏi Thường gặp',
      que1: 'Câu hỏi Thường gặp',
      content: 'Nội dung Phản hồi',
      contact: 'Thông tin Liên hệ',
      submit: 'Gửi phản hồi',
      tip1: 'Xin vui lòng cung cấp mô tả chi tiết, và bạn cũng có thể đính kèm ảnh chụp màn hình liên quan.',
      tip2: 'Vui lòng nhập email của bạn.',
      tip5: ' Kích thước hình ảnh tải lên phải nhỏ hơn {num}k.',
      tip6: 'Tối đa 4 hình ảnh có thể được tải lên.',
      tip3: 'Đã nộp, xin hãy kiên nhẫn.',
      tip4: 'Nội dung phản hồi cần có ít nhất 10 từ.',
      error: 'Lỗi Hệ Thống'
    }
  },
  tv: {
    vip: {
      title: 'Vui lòng chọn sản phẩm của bạn',
      tip1: 'Bạn có thể xem mã QR thanh toán sau khi đăng nhập.',
      refresh: 'Làm mới',
      tip2: 'Quét mã QR để thanh toán',
      recharge: 'Thỏa thuận Nạp tiền',
      renewal: 'Thỏa thuận Gia hạn',
      login: 'Đăng nhập ngay',
      tip3: 'Xem sau khi đăng nhập',
      noOpen: 'VIP Tiêu chuẩn chưa kích hoạt',
      gift: 'Quà tặng',
      succ: 'Làm mới thành công',
      fail: 'Làm mới thất bại',
      day: 'VIP tiêu chuẩn 1 ngày',
      days: 'VIP tiêu chuẩn {x} ngày',
      expiration: 'Thời gian hết hạn VIP tiêu chuẩn: {x}',
      expired: 'VIP của bạn đã hết hạn, vui lòng gia hạn ngay.',
      interests1: 'Thưởng thức chất lượng HD 1080P',
      interests2: 'Mở khóa tất cả nội dung',
      interests3: 'Đăng nhập trên nhiều thiết bị'
    }
  }
}